import lodash from 'lodash';
import VueMqMixin from "@/components/shared/mixins/VueMqMixin";

const PX_KEY = 'px';
const WINDOW_RESIZE_EVENT_NAME = 'resize';
const containerSelStringDesktop = '#navigation-drawer .content-container';
const containerSelStringMobile = '.mobile-container .content .outages-list-container';

export default {
    mixins: [VueMqMixin],
    data(){
        return {
            throttled: null,
            vueScrollOptions: {
                bar : {
                    size: '5px',
                    opacity: 0.5,
                    minSize: 0.25,
                    keepShow: true,
                    background: '#F0F0F0'
                }
            },
            selectors : {
                mobile: {
                    tabsContainerSelString: `${containerSelStringMobile} .tabs-container`,
                    searchContainerSelString: `${containerSelStringMobile} .outages-list-search`,
                    listContainerSelString: `${containerSelStringMobile} .list-container`,
                },
                desktop: {
                    listContainerSelString: `${containerSelStringDesktop} .list-container`,
                    bodySelString: `${containerSelStringDesktop} .body`,
                    tabsContainerSelString: `${containerSelStringDesktop} .tabs-container`,
                    searchContainerSelString: `${containerSelStringDesktop} .outages-list-search`,
                    footerContainerSelString: `${containerSelStringDesktop} .footer-container`
                }
            }
        }
    },
    methods: {
        getHeightAsInt ($el) {
            if (!$el) {
                return 0;
            }
            return parseInt(window.getComputedStyle($el).height.split(PX_KEY)[0], 10);
        },
        destroyScrollHelpers () {
            if (this.throttled) {
                window.removeEventListener(WINDOW_RESIZE_EVENT_NAME, this.throttled);
            }
        },
        initVueScrollHelpers () {
            const isMobile = this.isMobile() || this.isTablet();
            const setListHeightMethod =  isMobile ? this.setListHeightMobile : this.setListHeightDesktop;
            setTimeout(setListHeightMethod, 250);
            this.throttled = lodash.throttle(setListHeightMethod, 750);
            window.addEventListener(WINDOW_RESIZE_EVENT_NAME, this.throttled);
        },
        setListHeightMobile () {
            const selectors = this.selectors.mobile;
            const $outagesListContainer = document.querySelector(containerSelStringMobile);
            const $tabsContainer = document.querySelector(selectors.tabsContainerSelString);
            const $searchContainer = document.querySelector(selectors.searchContainerSelString);
            const $listContainer = document.querySelector(selectors.listContainerSelString);
            if (!$outagesListContainer || !$tabsContainer || !$searchContainer || !$listContainer) {
                return;
            }

            const outagesListContainerHeight = this.getHeightAsInt($outagesListContainer);
            const tabsContainerHeight = this.getHeightAsInt($tabsContainer);
            const searchContainerHeight = this.getHeightAsInt($searchContainer);

            const offset = (tabsContainerHeight + searchContainerHeight);
            const adjustedHeight = (outagesListContainerHeight - offset) - 150;

            $listContainer.style.height = `${adjustedHeight}${PX_KEY}`;
        },
        setListHeightDesktop () {
            const selectors = this.selectors.desktop;
            const $listContainer = document.querySelector(selectors.listContainerSelString);
            const $body = document.querySelector(selectors.bodySelString);
            const $tabsContainer = document.querySelector(selectors.tabsContainerSelString);
            const $searchContainer = document.querySelector(selectors.searchContainerSelString);
            const $footerContainer = document.querySelector(selectors.footerContainerSelString);
            if (!$listContainer || !$body || !$tabsContainer || !$searchContainer || !$footerContainer) {
                return;
            }

            const bodyHeight = this.getHeightAsInt($body);
            const tabsHeight = this.getHeightAsInt($tabsContainer);
            const searchHeight = this.getHeightAsInt($searchContainer);
            const footerHeight = this.getHeightAsInt($footerContainer);

            const offset = (tabsHeight + searchHeight + footerHeight) - 10;
            const adjustedHeight = bodyHeight - offset;

            $listContainer.style.height = `${adjustedHeight}${PX_KEY}`;
        }
      }
  };
